import React from 'react';
import PropTypes from 'prop-types';

import getElementType from '../Utils/getElementType';

/**
Il componente è stato pensato per renderizzare delle intestazioni.

Questo componente fa uno di un particolare metodo di renderizzazione, rappresentato dalla prop as.
Specificando in tale proprietà un tag HTML o un componente React, verrà disegnato esso per rappresentare il componente Heading.
 */
const Heading = (props) => {
  const {
    children,
    content,
    className,
    as,
    ...others
  } = props;
  const ElementType = getElementType(Heading, props);

  return (
    <ElementType
      {...others}
      className={className}
    >
      {content || children}
    </ElementType>
  );
};

Heading.propTypes = {
  /** Definisce il tag con il quale renderizzare il componente */
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  /** Contenuto da renderizzare all'interno del componente */
  children: PropTypes.node,
  /** Classi css personalizzate da aggiungere al componente */
  className: PropTypes.string,
  /** Contenuto da renderizzare all'interno del componente */
  content: PropTypes.node,
};

Heading.defaultProps = {
  as: '',
  children: null,
  className: '',
  content: null,
};

export default Heading;
